// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const indeedee_female: PokeData = {
  "id": 10186,
  "name": "indeedee-female",
  "height": 9,
  "weight": 280,
  "base_experience": 166,
  "types": [
    PokeType.PSYCHIC,
    PokeType.NORMAL
  ],
  "api_moves": [
    "psybeam",
    "psychic",
    "baton-pass",
    "follow-me",
    "helping-hand",
    "aromatherapy",
    "calm-mind",
    "healing-wish",
    "guard-split",
    "stored-power",
    "disarming-voice",
    "play-nice",
    "psychic-terrain"
  ],
  "moves": [
    "psychic",
    "aromatherapy",
    "calm-mind",
    "healing-wish",
    "psychic-terrain",
    "psychic-fangs",
    "psywave",
    "refresh",
    "splash",
    "scary-face",
    "reflect",
    "zen-headbutt",
    "purification"
  ],
  "evolution_chain": {
    "id": 458,
    "item": null,
    "species": [
      {
        "name": "indeedee",
        "order": 876,
        "types": [
          PokeType.PSYCHIC,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 132,
    "ability_power": 148
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
